import React, { FC, JSX } from "react";
import { ArrowUpRight } from "react-feather";
import { Link, useNavigate } from "react-router";

type Props = {
  icon: JSX.Element;
  link: string;
  title: string;
};

const LinkCard: FC<Props> = ({ icon, link, title }) => {
  const navigate = useNavigate();

  return (
    <div
      className="bg-gradient-to-r from-primary to-orange-400 w-56 p-6 rounded-md text-white cursor-pointer relative hover:scale-105 transition-transform"
      onClick={() => navigate(link)}
    >
      <ArrowUpRight className="absolute right-4 top-4" />
      <h1 className="text-xl font-normal">
        <span className="text-lg font-light">Click to</span> <br /> Create Order
      </h1>
    </div>
  );
};

export default LinkCard;
